import { createGlobalStyle } from "styled-components"
import theme from './themes/dark'

type MyProps = {
    theme: typeof theme
}

export default createGlobalStyle<MyProps>`
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }

    body {
        padding: 16px 10%;
        font-family: 'Montserrat';
        color: ${props => props.theme.colors.text};
        background-color: ${props => props.theme.colors.background};
    }

    body.overflow {
        overflow: hidden;
    }

    a {
        text-decoration: none;
        color: ${props => props.theme.colors.text};
    }

    html {
        scroll-behavior: smooth;
    }
`